"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense } from "react";
import { AppProviders } from "@/components/AppProviders";
import { BlacksmithLogomarkAnimationSVG } from "@/components/BlacksmithLogoSVG";
import { DashboardRouterProvider, useDashboardRouter } from "@/hooks/useDashboardRouter";
import { OrgUrlSyncProvider } from "@/components/OrgUrlSyncProvider";
import { SidebarLayout } from "@/components/SidebarLayout";
import { isCodesmithExtensionEmbed } from "@/lib/codesmithExtensionEmbed";

// DashboardRouterProvider reads useSearchParams, which bails the prerender out
// to the client, so this is the HTML shown until hydration. It mirrors the
// server branch of AuthProvider's initial-load state; the sidebar skeleton
// needs the router and localStorage, so it can only render after hydration.
function DashboardShellFallback() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-screen items-center justify-center"><div className="w-32 h-32"><BlacksmithLogomarkAnimationSVG /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

// The Chrome extension iframe (`?embed=extension`) renders the page bare, as
// `_app.tsx` does: no rail, sidebars, command palette, shortcuts modal, or
// the shell's prefetch hooks. The page still needs a Suspense boundary below
// AppProviders: pages that suspend at their root (the PR resolver reads
// useActiveGithubOrgForUser there) would otherwise bubble to the layout
// boundary, discarding the query client and auth tree and re-suspending on
// the fresh cache.
function DashboardShell(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const router = useDashboardRouter();
  let t1;
  if ($[0] !== children || $[1] !== router.query.embed) {
    t1 = <OrgUrlSyncProvider>{isCodesmithExtensionEmbed(router.query.embed) ? <Suspense fallback={<DashboardShellFallback />}>{children}</Suspense> : <SidebarLayout>{children}</SidebarLayout>}</OrgUrlSyncProvider>;
    $[0] = children;
    $[1] = router.query.embed;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export default function DashboardLayout(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DashboardShellFallback />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Suspense fallback={t1}><DashboardRouterProvider><AppProviders><DashboardShell>{children}</DashboardShell></AppProviders></DashboardRouterProvider></Suspense>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}